import { provider as sentryProvider } from 'utils/integrations/Sentry';
import listeners, { Listener } from 'utils/publicEvents/listeners';
import { PublicEvent, PublicEvents } from 'utils/publicEvents/events';
import storage from 'utils/publicEvents/events/storage';

type PublicEventsKeys = keyof typeof PublicEvents;

type PublicContext = {
  on: (eventName: string, callback: Listener['call'], callHistory: boolean) => void;
  events: { [key in PublicEventsKeys]: string };
};

const callListenersWithEvent = (listeners: Listener[], event: PublicEvent): void => {
  listeners.forEach((listener) => {
    try {
      listener.call(event.data);
    } catch (e) {
      sentryProvider.getSentry().captureException(e);
    }
  });
};

const dispatch = (event: PublicEvent): void => {
  const listenersByName = listeners.getByEventName(event.name);
  callListenersWithEvent(listenersByName, event);
  storage.add(event);
};

const on = (eventName: string, callback: Listener['call'], callHistory: boolean = false): void => {
  listeners.addListener(listeners.create(eventName, callback));
  if (callHistory) {
    const historyEvents = storage.getByName(eventName);
    historyEvents.forEach((event) => {
      callback(event.data);
    });
  }
};

const createPublicContext = (): PublicContext => ({
  on,
  events: {
    ...PublicEvents,
  },
});

const exportObject = {
  dispatch,
  on,
  createPublicContext,
};

export default exportObject;
